import { Eyebrow, Reveal } from "./Reveal";

const STATS = [
  { value: "Since 2005", label: "Active in TSCM and professional bug sweeping", small: true },
  {
    value: "Approximately 6,000",
    label: "Sweeps carried out, an estimate of work to date",
    note: "One sweep is one inspection visit: one room, many rooms or one vehicle.",
    small: true,
  },
  { value: "7–8 years", label: "Average experience of the current technical team", small: true },
  { value: "Continuing", label: "Manufacturer and partner-led technical training", small: true },
];

export default function Experience() {
  return (
    <section id="experience" className="border-b border-hairline py-12 sm:py-16" data-testid="experience-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Experience &amp; technical leadership</Eyebrow>
          <h3 className="mt-4 max-w-2xl font-head font-extrabold tracking-tight h-sec">
            Field experience since 2005. Knowledge shared with specialist users.
          </h3>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-sub">
            TSCM Services combines long-running field practice, continuing
            equipment training and an experienced engineering team. We do not
            name confidential clients, and no government agency is named or
            implied to endorse us.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-px border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map(({ value, label, small }, i) => (
            <div key={label} className="bg-base-color">
              <Reveal delay={i * 0.07} className="h-full">
                <div className="flex h-full flex-col gap-3 px-6 py-8" data-testid={`experience-stat-${i + 1}`}>
                  <span className={`font-head font-extrabold tracking-tight text-violet ${small ? "text-2xl sm:text-3xl" : "text-4xl sm:text-5xl"}`}>
                    {value}
                  </span>
                  <span className="text-sm uppercase leading-relaxed tracking-[0.16em] text-sub">
                    {label}
                  </span>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
